import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function OmOss() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Update page title and meta description
    document.title = 'Om Easy Accounting AS | Statsautoriserte Regnskapsførere Oslo';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Møt teamet bak Easy Accounting AS – statsautoriserte regnskapsførere i Oslo siden 2013. Over 500 fornøyde kunder. Fozia Saleem, Haider Ali Chishti og teamet er klare til å hjelpe din bedrift.');
    }
    
    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', 'https://easy.no/om-oss');
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "mainEntity": {
        "@type": "Organization",
        "name": "Easy Accounting AS",
        "url": "https://easy.no",
        "foundingDate": "2013",
        "description": "Easy Accounting AS ble grunnlagt i 2013 med en klar visjon: å gjøre regnskapsarbeid enkelt og tilgjengelig for alle typer bedrifter.",
        "numberOfEmployees": "5-10",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Brynsveien 2",
          "addressLocality": "Oslo",
          "postalCode": "0667",
          "addressCountry": "NO"
        },
        "employee": [
          {
            "@type": "Person",
            "name": "Fozia Saleem",
            "jobTitle": "Daglig leder / Statsautorisert regnskapsfører",
            "worksFor": {
              "@type": "Organization",
              "name": "Easy Accounting AS"
            }
          },
          {
            "@type": "Person",
            "name": "Haider Ali Chishti",
            "jobTitle": "Kvalitetssjef / Statsautorisert regnskapsfører",
            "worksFor": {
              "@type": "Organization",
              "name": "Easy Accounting AS"
            }
          },
          {
            "@type": "Person",
            "name": "Agata Ejtel",
            "jobTitle": "Statsautorisert regnskapsfører",
            "worksFor": {
              "@type": "Organization",
              "name": "Easy Accounting AS"
            }
          },
          {
            "@type": "Person",
            "name": "Theseekaran Ponnuthurai",
            "jobTitle": "Statsautorisert regnskapsfører",
            "worksFor": {
              "@type": "Organization",
              "name": "Easy Accounting AS"
            }
          },
          {
            "@type": "Person",
            "name": "Santosh Baniya",
            "jobTitle": "Statsautorisert regnskapsfører",
            "worksFor": {
              "@type": "Organization",
              "name": "Easy Accounting AS"
            }
          }
        ]
      }
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  const team = [
    {
      name: 'Fozia Saleem',
      role: 'Daglig leder / Statsautorisert regnskapsfører',
      education: 'Statsautorisert regnskapsfører',
      experience: '15+ år erfaring',
      languages: 'Behersker Norsk, Urdu og Engelsk',
      image: 'https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/c0e795687fa68b7726c5d64d54604af5.jfif'
    },
    {
      name: 'Haider Ali Chishti',
      role: 'Kvalitetssjef / Statsautorisert regnskapsfører',
      education: 'Statsautorisert regnskapsfører',
      experience: '12+ år erfaring',
      languages: 'Behersker Norsk, Urdu og Engelsk',
      image: 'https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/7c24d3674be9ac1f6f7cfda8bcb8d547.jfif'
    },
    {
      name: 'Agata Ejtel',
      role: 'Statsautorisert regnskapsfører',
      education: 'Statsautorisert regnskapsfører',
      experience: '12+ år erfaring',
      languages: 'Behersker Norsk, Polsk og Engelsk',
      image: 'https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/20b595f39cf618f5e0167729037de621.jfif'
    },
    {
      name: 'Theseekaran Ponnuthurai',
      role: 'Statsautorisert regnskapsfører',
      education: 'Statsautorisert regnskapsfører',
      experience: '12+ år erfaring',
      languages: 'Behersker Norsk, Tamilsk og Engelsk',
      image: 'https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/4df3a7c45c163b7cb3b50656fab2a0f4.jfif'
    },
    {
      name: 'Santosh Baniya',
      role: 'Statsautorisert regnskapsfører',
      education: 'Statsautorisert regnskapsfører',
      experience: '8+ år erfaring',
      languages: 'Behersker Norsk, Nepalsk og Engelsk',
      image: 'https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/8c42c38f6849fd27c92e9a0e8e2062f7.jfif'
    }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Pålitelighet',
      description: 'Vi leverer alltid det vi lover, til avtalt tid og med høy kvalitet.'
    },
    {
      icon: 'ri-user-heart-line', 
      title: 'Personlig service',
      description: 'Hver kunde får en fast kontaktperson som kjenner bedriften din.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovasjon',
      description: 'Vi bruker moderne teknologi for å effektivisere regnskapsarbeidet.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Kvalitet',
      description: 'Høy faglig kompetanse og kontinuerlig oppdatering på regelverket.'
    }
  ];

  const milestones = [
    {
      year: '2013',
      title: 'Etablering',
      description: 'Easy Accounting AS ble etablert med visjonen om å forenkle regnskap for norske bedrifter.'
    },
    {
      year: '2017',
      title: 'Vekst',
      description: 'Utvidet teamet og flyttet til større lokaler for å betjene flere kunder.'
    },
    {
      year: '2020',
      title: 'Digitalisering',
      description: 'Implementerte moderne skybaserte regnskapssystemer for bedre effektivitet.'
    },
    {
      year: '2025',
      title: 'I dag',
      description: 'Over 500 fornøyde kunder og et team på statsautorisert regnskapsførere.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-16 sm:py-24 bg-gradient-to-r from-blue-600 to-blue-800 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-10 sm:top-20 left-4 sm:left-20 w-16 sm:w-20 h-16 sm:h-20 bg-white/10 rounded-full animate-bounce" style={{ animationDelay: '0s', animationDuration: '3s' }}></div>
          <div className="absolute bottom-10 sm:bottom-20 right-4 sm:right-20 w-12 sm:w-16 h-12 sm:h-16 bg-white/10 rounded-full animate-bounce" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
        </div>
        <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4 sm:mb-6 animate-fade-in-up">
            Om Easy Accounting AS
          </h1>
          <p className="text-lg sm:text-xl text-blue-100 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Din pålitelige partner for regnskaps- og bokføringstjenester siden 2013
          </p>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div className="animate-fade-in-left">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mb-4 sm:mb-6">
                Vår historie
              </h2>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6">
                Easy Accounting AS ble grunnlagt i 2013 med en klar visjon: å gjøre regnskapsarbeid enkelt og tilgjengelig for alle typer bedrifter. Vi startet som et lite regnskapsbyrå med stor ambisjoner om å levere personlig service og høy faglig kvalitet.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6">
                I dag er vi et veletablert regnskapsbyrå med over 500 fornøyde kunder og et team av statsautorisert regnskapsførere. Vi har hjulpet hundrevis av bedrifter med å holde orden på økonomien, fra oppstart til vekst og utvikling.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8">
                Vår suksess bygger på sterke relasjoner med våre kunder, kontinuerlig faglig utvikling og evnen til å tilpasse oss endringer i et dynamisk forretningslandskap.
              </p>
              <Link to="/kontakt">
                <Button className="hover:scale-105 transition-transform duration-300 whitespace-nowrap">
                  Kontakt oss i dag
                </Button>
              </Link>
            </div>
            <div className="relative animate-fade-in-right">
              <img
                src="https://public.readdy.ai/ai/img_res/01fec0549871a723db6fe6d8ae8c6e91.jpg"
                alt="Våre kontorer"
                className="rounded-lg shadow-lg object-cover w-full h-64 sm:h-80 lg:h-96 hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-16 sm:py-24 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 animate-fade-in-up">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mb-3 sm:mb-4">
              Våre verdier
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              De grunnleggende prinsippene som styrer alt vi gjør
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {values.map((value, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl p-6 sm:p-8 text-center shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-2 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-12 sm:w-16 h-12 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 animate-pulse">
                  <i className={`${value.icon} text-xl sm:text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                  {value.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 animate-fade-in-up">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mb-3 sm:mb-4">
              Møt vårt team
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Erfarne regnskapsførere som brenner for å hjelpe bedrifter
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
            {team.map((member, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-all duration-300 hover:-translate-y-2 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-blue-600 font-medium mb-2 sm:mb-3 text-sm sm:text-base">
                    {member.role}
                  </p>
                  <p className="text-gray-600 text-xs sm:text-sm mb-1 sm:mb-2">
                    {member.education}
                  </p>
                  <p className="text-gray-600 text-xs sm:text-sm mb-1 sm:mb-2">
                    {member.experience}
                  </p>
                  {member.languages && (
                    <p className="text-gray-600 text-xs sm:text-sm">
                      {member.languages}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-16 sm:py-24 bg-blue-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 animate-fade-in-up">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mb-3 sm:mb-4">
              Vår reise
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Viktige milepæler i Easy Accounting AS sin utvikling
            </p>
          </div>
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-blue-200 hidden sm:block"></div>
            <div className="space-y-8 sm:space-y-12">
              {milestones.map((milestone, index) => (
                <div 
                  key={index} 
                  className={`relative flex items-center ${index % 2 === 0 ? 'sm:justify-start' : 'sm:justify-end'} animate-fade-in-up`}
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  <div className={`w-full sm:max-w-lg ${index % 2 === 0 ? 'sm:pr-8' : 'sm:pl-8'}`}>
                    <div className="bg-white rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                      <div className="flex items-center mb-2 sm:mb-3">
                        <span className="text-xl sm:text-2xl font-bold text-blue-600 mr-2 sm:mr-3">
                          {milestone.year}
                        </span>
                        <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
                          {milestone.title}
                        </h3>
                      </div>
                      <p className="text-gray-600 text-sm sm:text-base">
                        {milestone.description}
                      </p>
                    </div>
                  </div>
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-3 sm:w-4 h-3 sm:h-4 bg-blue-600 rounded-full border-2 sm:border-4 border-white animate-pulse hidden sm:block"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-24 bg-gradient-to-r from-blue-600 to-blue-800 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-6 sm:top-10 left-4 sm:left-10 w-24 sm:w-32 h-24 sm:h-32 bg-white/5 rounded-full animate-spin" style={{ animationDuration: '20s' }}></div>
          <div className="absolute bottom-6 sm:bottom-10 right-4 sm:right-10 w-16 sm:w-24 h-16 sm:h-24 bg-white/5 rounded-full animate-spin" style={{ animationDuration: '15s', animationDirection: 'reverse' }}></div>
        </div>
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 sm:mb-6 animate-fade-in-up">
            Klar til å bli vår neste suksesshistorie?
          </h2>
          <p className="text-lg sm:text-xl text-blue-100 mb-6 sm:mb-8 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            La oss hjelpe deg med å ta kontroll over bedriftens økonomi
          </p>
          <Link to="/kontakt">
            <Button variant="outline" size="lg" className="text-white border-white hover:bg-white hover:text-blue-600 hover:scale-105 transition-all duration-300 animate-fade-in-up whitespace-nowrap" style={{ animationDelay: '0.4s' }}>
              Kontakt oss i dag
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
